import { render, staticRenderFns } from "./AddOrEditBranchByForm.vue?vue&type=template&id=32bfcc10"
import script from "./AddOrEditBranchByForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditBranchByForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports